import React from 'react';
import { Mail, MapPin, Leaf, Phone, Twitter, Linkedin } from 'lucide-react';
import { mockData } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            {/* <div className="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_guargum-central/artifacts/twynfr4y_Screenshot%202025-09-29%20111936.png" 
                alt="GreenZaar Logo" 
                className="footer-logo-img"
              />
            </div> */}
            <p className="footer-description">
              {mockData.company.description}
            </p>
            <div className="footer-locations">
              <MapPin size={16} />
              <span>Global Operations: USA & India</span>
            </div>
          </div>
          
          {/* Products */}
          <div className="footer-section">
            <h4 className="footer-title">Our Products</h4>
            <ul className="footer-links">
              <li><a href="#products">Food Grade Guar Gum</a></li>
              <li><a href="#products">Industrial Grade</a></li>
              <li><a href="#products">Pharmaceutical Grade</a></li>
              <li><a href="#products">Custom Specifications</a></li>
            </ul>
          </div>
          
          {/* Industries */}
          <div className="footer-section">
            <h4 className="footer-title">Industries</h4>
            <ul className="footer-links">
              <li><a href="#applications">Food & Beverage</a></li>
              <li><a href="#applications">Oil & Gas</a></li>
              <li><a href="#applications">Textile Industry</a></li>
              <li><a href="#applications">Pharmaceuticals</a></li>
              <li><a href="#applications">Paper & Pulp</a></li>
            </ul>
          </div>
          
          {/* Contact */}
          <div className="footer-section">
            <h4 className="footer-title">Contact Us</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <Mail size={16} />
                <a href={`mailto:${mockData.company.email}`}>
                  {mockData.company.email}
                </a>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <div>
                  <strong>USA Office:</strong><br/>
                  {mockData.company.addresses.usa.street}<br/>
                  {mockData.company.addresses.usa.suite}<br/>
                  {mockData.company.addresses.usa.city}, {mockData.company.addresses.usa.state} {mockData.company.addresses.usa.zip}
                </div>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <div>
                  <strong>India Office:</strong><br/>
                  {mockData.company.addresses.india.street}<br/>
                  {mockData.company.addresses.india.city}, {mockData.company.addresses.india.district}<br/>
                  {mockData.company.addresses.india.state} {mockData.company.addresses.india.pin}
                </div>
              </div>
              <div className="contact-item">
                <Phone size={16} />
                <span className="phone-numbers">
                  USA: {mockData.company.phones.usa}<br/>
                  India: {mockData.company.phones.india}
                </span>
              </div>
            </div>
            
            {/* Social Media */}
            <div className="footer-social">
              <h4 className="footer-title">Follow Us</h4>
              <div className="social-links">
                <a href={mockData.company.social.twitter} target="_blank" rel="noopener noreferrer" className="social-link">
                  <Twitter size={20} />
                  <span>Twitter</span>
                </a>
                <a href={mockData.company.social.linkedin} target="_blank" rel="noopener noreferrer" className="social-link">
                  <Linkedin size={20} />
                  <span>LinkedIn</span>
                </a>
              </div>
            </div>
            {/* <div className="footer-cta">
              <a href="#contact" className="btn-primary">
                Get Quote
              </a>
            </div> */}
            
          </div>
        </div>
        
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} {mockData.company.name}. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <a href="#quality">Quality Assurance</a>
              <a href="#contact">Privacy Policy</a>
              <a href="#contact">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Footer Styles
const styles = `
.footer {
  background: var(--brand-dark);
  color: white;
  padding: var(--spacing-giant) 0 0;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 2fr;
  gap: var(--spacing-xl);
  margin-bottom: var(--spacing-xl);
}

.footer-section {
  display: flex;
  flex-direction: column;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: var(--spacing-medium);
  color: var(--brand-primary);
}

.footer-logo-img {
  height: 60px;
  width: auto;
  background: white;
  border-radius: 8px;
  padding: 8px;
}

.footer-description {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin-bottom: var(--spacing-medium);
  font-size: 14px;
}

.footer-locations {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.footer-title {
  font-size: 16px;
  font-weight: 600;
  color: white;
  margin-bottom: var(--spacing-medium);
}

.footer-links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer-links li {
  margin-bottom: 8px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: var(--brand-primary);
}

.footer-contact {
  margin-bottom: var(--spacing-medium);
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.contact-item a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 14px;
}

.contact-item a:hover {
  color: var(--brand-primary);
}

.footer-cta {
  margin-top: auto;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: var(--spacing-medium) 0;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copyright {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  margin: 0;
}

.footer-bottom-links {
  display: flex;
  gap: var(--spacing-medium);
}

.footer-bottom-links a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s ease;
}

.footer-bottom-links a:hover {
  color: var(--brand-primary);
}

.footer-social {
  margin-top: var(--spacing-medium);
}

.social-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.social-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 14px;
  padding: 8px 0;
  transition: color 0.2s ease;
}

.social-link:hover {
  color: var(--brand-primary);
}

.contact-item div {
  line-height: 1.4;
}

@media (max-width: 1024px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-large);
  }
}

@media (max-width: 781px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: var(--spacing-large);
  }
  
  .footer-bottom-content {
    flex-direction: column;
    gap: var(--spacing-small);
    text-align: center;
  }
  
  .footer-bottom-links {
    justify-content: center;
  }
}
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}